const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de integraciones',
  PAGE_DESCRIPTION:
    'En esta página puedes ver y crear integraciones con los distintos proveedores a los que Rayo da soporte.'
};

export default HELPER_TEXTS;
